// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__bFudp","title":"InfoRow_title__3qzpG"};